import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, type OnInit, inject, input } from '@angular/core';
import { AuthService } from '../../shared/services/auth/auth.service';
import { StorageService } from '../../shared/services/storage/storage.service';
import { Router } from '@angular/router';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'dpqa-callback',
  imports: [CommonModule, LoadingSpinnerComponent],
  template: `
    <div class="loading-container">
      <dpqa-loading-spinner />
    </div>
  `,
  styles: [
    `
      .loading-container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 10rem;
      }
    `,
  ],
})
export class CallbackComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly storageService = inject(StorageService);
  private readonly router = inject(Router);

  public code = input.required<string>();
  public state = input.required<string>();

  ngOnInit(): void {
    const state = this.storageService.get<string>('state');

    if (state && this.state() === state) {
      this.authService.exchangeAccessToken(this.code()).subscribe(() => {
        const redirectUri = this.storageService.get<string>('redirect_uri');

        // TODO: We are assuming here that /slides is accessible for every user but this might not always be the case based on their permissions.
        // We don't have access to the user context though, as its only loaded after this callback resolves.
        // Needs a more robust solution in the future, but this will do for now.
        const url = this.router.parseUrl(redirectUri || '/slides');
        this.router.navigateByUrl(url, { replaceUrl: true });
      });
    } else {
      this.authService.logout();
    }
  }
}
